import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CmsFooterComponent } from '@fcom/cms/components';
import { createRoute } from '@fcom/common';
import { ErrorComponent, HeaderComponent, NavigationModule } from '@fcom/common/components';
import { LoyaltyRoutesPath } from '@fcom/loyalty-core/interfaces';
import { LoyaltyMyTripsComponent } from '@fcom/loyalty-core/views/loyalty-my-trips/loyalty-my-trips.component';
import { LoyaltyLayoutComponent } from '@fcom/loyalty-core/views/loyalty-layout/loyalty-layout.component';

import { PlusDashboardComponent } from './views/plus-dashboard/plus-dashboard.component';
import { PlusProfileComponent } from './views/plus-profile/plus-profile.component';
import { BalanceAndTransactionsComponent } from './views/balance-and-transactions/balance-and-transactions.component';
import { TierProgressAndBenefitsComponent } from './views/tier-progress-and-benefits/tier-progress-and-benefits.component';
import { BuyPointsComponent } from './views/buy-points/buy-points.component';
import { UpgradeTravelClassComponent } from './views/upgrade-travel-class/upgrade-travel-class.component';
import { PlusUserGuard } from './services/plus-user.guard';
import { BuyPointsGuard } from './services/buy-points.guard';
import { UpgradeTravelClassGuard } from './services/upgrade-travel-class.guard';
import { CampaignEnrollComponent } from './views/campaign-enroll/campaign-enroll.component';
import { LoyaltyOverhaulGuard } from './services/loyalty-overhaul.guard';

export const plusRoutes: Routes = [
  {
    path: '',
    component: LoyaltyLayoutComponent,
    children: [
      { path: '', component: HeaderComponent, outlet: 'header' },
      { path: '', component: CmsFooterComponent, outlet: 'footer' },
      createRoute({ path: '' }, PlusDashboardComponent, [], [PlusUserGuard]),
      createRoute({ path: `${LoyaltyRoutesPath.PROFILE}` }, PlusProfileComponent, [], [PlusUserGuard]),
      createRoute(
        { path: `${LoyaltyRoutesPath.BALANCE_AND_TRANSACTIONS}` },
        BalanceAndTransactionsComponent,
        [],
        [PlusUserGuard]
      ),
      createRoute(
        { path: `${LoyaltyRoutesPath.UPGRADE_AVAILABILITY}` },
        UpgradeTravelClassComponent,
        [],
        [PlusUserGuard, UpgradeTravelClassGuard]
      ),
      createRoute({ path: `${LoyaltyRoutesPath.MY_TRIPS}` }, LoyaltyMyTripsComponent, [], [PlusUserGuard]),
      createRoute(
        { path: `${LoyaltyRoutesPath.TIER_PROGRESS_AND_BENEFITS}` },
        TierProgressAndBenefitsComponent,
        [],
        [PlusUserGuard, LoyaltyOverhaulGuard]
      ),
      createRoute({ path: `${LoyaltyRoutesPath.BUY_POINTS}` }, BuyPointsComponent, [], [PlusUserGuard, BuyPointsGuard]),
      createRoute({ path: `${LoyaltyRoutesPath.CAMPAIGN_ENROLL}` }, CampaignEnrollComponent, [], []),
      createRoute({ path: `${LoyaltyRoutesPath.ERROR}` }, ErrorComponent, [], []),
    ],
  },
];

@NgModule({
  imports: [NavigationModule, RouterModule.forChild(plusRoutes)],
  declarations: [],
  providers: [PlusUserGuard, BuyPointsGuard, UpgradeTravelClassGuard, LoyaltyOverhaulGuard],
  exports: [RouterModule],
})
export class PlusRouteModule {}
